import initSite from './utils/dom/initSite.mjs'
import slideshow from './utils/dom/slideshow.mjs'
import headerClass from './utils/dom/headerClass.mjs'
import windowHeight from './utils/dom/windowHeight.mjs'
import scrollHeight from './utils/dom/scrollHeight.mjs'
import inViewClass from './utils/dom/inViewClass.mjs'
import ajaxForm from './utils/dom/ajaxForm.mjs'

import setupAnimations from './modules/animations.mjs'
import { CountUp } from './lib/countUp.min.mjs'

initSite([
  setupAnimations,
  () => slideshow({
    beforeInit (index, $slides, $controls, $container) {
      const $animations = $container.querySelectorAll(`[data-animation]`)
      const $animation = $animations[0]
      if ($animation && window.animations) {
        const animationName = $animation.dataset.animation
        const animation = window.animations[animationName]
        animation.addEventListener('data_ready', function () {
          setTimeout(() => {
            animation.isActive = true
            animation.playSegments([0, animation.markers.in], true)
          }, 100)
        })
      }
    },
    onChange (index, $slide, $control, $container) {
      const $input = [...$container.querySelectorAll('input')][index - 1]
      if ($input) $input.checked = true

      const $animations = $container.querySelectorAll(`[data-animation]`)
      $animations.forEach($animation => {
        if ($animation && window.animations) {
          const animationName = $animation.dataset.animation
          const animation = window.animations[animationName]
          if (animation.isActive) {
            animation.isActive = false
            animation.loop = false
            const markers = animation.markers
            animation.playSegments([markers.loop, markers.out], true)
          }
        }
      })

      const $animation = $slide.parentElement.querySelector(`[data-animation]`)
      if ($animation && window.animations) {
        const animationName = $animation.dataset.animation
        const animation = window.animations[animationName]
        const markers = animation.markers
        if (markers) {
          setTimeout(() => {
            animation.playSegments([[0, markers.in], [markers.in, markers.loop]], true)
          }, 500)
          animation.isActive = true
          animation.loop = true
        }
      }
    },
  }),
  headerClass,
  windowHeight,
  scrollHeight,
  () => {
    const $wildscape = document.querySelector(`[data-wildscape]`)
    if (!$wildscape) return

    const $areas = $wildscape.querySelectorAll(`[data-area]`)
    const setCurrentAreaIndex = index => {
      $areas.forEach(($area, i) => {
        $area.classList.toggle('active', i === index)
      })
    }

    $areas.forEach(($area, i) => {
      $area.querySelector('.area-title-bg').addEventListener('click', () => {
        $areas.forEach(($area, i) => {
          setCurrentAreaIndex(i)
        })
      })
    })
    setCurrentAreaIndex(0)

    slideshow({
      containerIdentifier: 'data-wildscape',
      beforeInit(index, $slides, $controls, $container) {},
      onChange(index, $slide, $control, $container) {
        const $areaListItem = $slide.closest(`[data-area-index]`)
        const currentAreaIndex = parseInt($areaListItem.dataset.areaIndex)
        setCurrentAreaIndex(currentAreaIndex)

        $areas.forEach($area => {
          $area.querySelectorAll('.dots > *')
            .forEach($dot => {
              $dot.classList.remove('active')
            })
        })

        const $currentAreaDots = [...($areas[currentAreaIndex]).querySelectorAll('.dots > *')]
        // const randomDot = $currentAreaDots[Math.floor(Math.random() * $currentAreaDots.length)]
        // randomDot.classList.add('active')
        $currentAreaDots.forEach(($dot, i) => {
          $dot.classList.toggle('active', i === index)
        })
      }
    })
  },
  () => inViewClass({
    onIntersecting ($el) {
      if ($el.dataset['count'] && $el.counted !== true) {
        $el.counted = true
        const countUp = new CountUp($el, $el.dataset['count'], {
          decimalPlaces: $el.dataset['count'] > 9 ? 0 : 1
        })
        setTimeout(() => countUp.start(), 500)
      }

      if ($el.dataset.hasOwnProperty('playOnScroll')) {
        window.animations[$el.dataset.animation]?.play()
      }
    }
  }),
  ajaxForm,
], false)